import pusher from '../pusher'
import { accommodationGallerySliderMapper } from '../mappers/accommodation-gallery/accommodation-gallery-slider-mapper'

export function listenSliderEvents (event, track) {
  event.on('change', () => {
    const mappedData = accommodationGallerySliderMapper(track)
    pusher.pushDataObject(mappedData)
  })
}
